module.exports = __webpack_public_path__ + "media/customizations/reverie/logo-522098052a525fcb618878ae97fd0861.png";